import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { BaseStore } from '../../stores/base.store';
import { SelectHelper } from './select.hepler';

type State = {
  search: boolean; // 검색 기능 사용 여부
  currentValue: any; // 현재 선택된 값
};

@Injectable({ providedIn: 'any' })
export class SelectStore extends BaseStore<State> {
  search = toSignal(this.state$.pipe(map((state) => state.search)));
  currentValue = toSignal(this.state$.pipe(map((state) => state.currentValue)));

  constructor() {
    super({
      search: true,
      currentValue: '',
    });
  }

  init(state: State) {
    this.updateState(state);
  }

  setCurrentValue(value: any) {
    this.updateState({ currentValue: value });
  }

  getLabel(option: any, bindLabel: string) {
    return SelectHelper.get(option, bindLabel || '');
  }

  getValue(option: any, bindValue: string) {
    return SelectHelper.get(option, bindValue || '');
  }
}
